import { Tag as t } from "@flightpath/coreui";

const Tag = t.Tag;
export { Tag };
